export const blockIconsNavigationDoubleArrow = (
	<span className='material-symbols-outlined'>double_arrow</span>
);
